<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    Sales Invoice Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Sales Invoice Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <DailySalesReportMargin v-if="currentProfile == 'daily_sales_invoice_with_margins'"/>
                    <DailySalesReport v-if="currentProfile == 'daily_sales_invoices'"/>
                    <ReturnsReport v-if="currentProfile == 'returns_reports'"/>
                    <MarginSalesReport v-if="currentProfile == 'margin_sales_reports'"/>
                    <DetailedSoldOutReport v-if="currentProfile == 'detailed_sold_out_reports'" />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import DailySalesReportMargin from './DailySalesReportMargin.vue';
    import DailySalesReport from './DailySalesReport.vue';
    import ReturnsReport from './ReturnsReport.vue';
    import MarginSalesReport from './MarginSalesReport.vue';
    import DetailedSoldOutReport from './DetailedSoldOutReport.vue';

    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: []
            }
        },
        components: {
            DailySalesReportMargin,
            DailySalesReport,
            ReturnsReport,
            MarginSalesReport,
            DetailedSoldOutReport
        },
        mounted: async function () {

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF


          let newActiveModules = [];
          var component_x = this;

          var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=R-003-AR&status=A', null, null)
          if(categoryId[0] != undefined){
            component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)

            // Check if user has permission for Basic Inventory Reports (R-002) Physical Count - Variance Report (BI-008)
            const userActiveModulesURL = `${component_x.endPoint}/system_module_categories/user_enabled_modules?category_codes=R-003-AR`;
            const userActiveModules = await HTTPRequest.getRequest(userActiveModulesURL, null, null);

            if (userActiveModules.enabled_modules.length > 0) {
              let activeModuleNames = [];
              userActiveModules.enabled_modules.map(module => { activeModuleNames.push(module.name) })
              // const newActiveModules = component_x.activeModules.filter(module => module.name != "Physical Count - Variance Report");
              newActiveModules = component_x.activeModules.filter(module => activeModuleNames.includes(module.name) );
              component_x.activeModules = newActiveModules;
            }

            component_x.activeModules = newActiveModules;

            if (component_x.activeModules.length > 0) {
              var profile = _.snakeCase(component_x.activeModules[0].name)
              component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
            } else {
              component_x.setCurrentProfile(null, null);
            }
          }
        },
        watch: {
            currentProfile: function() {
                // console.log(this.currentProfile)
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>
